import { Injectable, PLATFORM_ID, signal, effect, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  DISPLAYED_BOX_COLUMNS,
  DISPLAYED_CUSTOMER_COLUMNS,
  DISPLAYED_USER_COLUMNS,
  DISPLAYED_PARTNER_COLUMNS,
  ITEMS_PER_PAGE,
  DISPLAYED_MODULE_CONFIG_COLUMNS,
  DISPLAYED_ADMIN_USER_COLUMNS,
} from '../constants';
import { CustomerColumn, PartnerColumn, UserColumn } from '../enums';
import { AuthStore } from '../stores';
import { ModuleConfigColumn } from '../enums/module-config-column.enum';
import { CustomerBoxColumn } from '../../pages/main/cybersecurity-cockpit/customer-boxes/customer-box-column.enum';

@Injectable({ providedIn: 'root' })
export class ApplicationService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);

  displayedModuleConfigColumns = signal<string[]>([]);
  displayedBoxColumns = signal<string[]>([]);
  displayedCustomerColumns = signal<string[]>([]);
  displayedUserColumns = signal<string[]>([]);
  displayedAdminUserColumns = signal<string[]>([]);
  displayedPartnerColumns = signal<string[]>([]);
  itemsPerPage = signal<number>(20);

  constructor() {
    effect(() => {
      const displayedModuleConfigColumns = this.displayedModuleConfigColumns();
      if (displayedModuleConfigColumns.length) {
        localStorage.setItem(DISPLAYED_MODULE_CONFIG_COLUMNS, JSON.stringify(displayedModuleConfigColumns));
      } else {
        localStorage.removeItem(DISPLAYED_MODULE_CONFIG_COLUMNS);
      }
    });
    effect(() => {
      const boxColumns = this.displayedBoxColumns();
      if (boxColumns.length) {
        localStorage.setItem(DISPLAYED_BOX_COLUMNS, JSON.stringify(boxColumns));
      } else {
        localStorage.removeItem(DISPLAYED_BOX_COLUMNS);
      }
    });
    effect(() => {
      const customerColumns = this.displayedCustomerColumns();
      if (customerColumns.length) {
        localStorage.setItem(DISPLAYED_CUSTOMER_COLUMNS, JSON.stringify(customerColumns));
      } else {
        localStorage.removeItem(DISPLAYED_CUSTOMER_COLUMNS);
      }
    });
    effect(() => {
      const userColumns = this.displayedUserColumns();
      if (userColumns.length) {
        localStorage.setItem(DISPLAYED_USER_COLUMNS, JSON.stringify(userColumns));
      } else {
        localStorage.removeItem(DISPLAYED_USER_COLUMNS);
      }
    });
    effect(() => {
      const userColumns = this.displayedAdminUserColumns();
      if (userColumns.length) {
        localStorage.setItem(DISPLAYED_ADMIN_USER_COLUMNS, JSON.stringify(userColumns));
      } else {
        localStorage.removeItem(DISPLAYED_ADMIN_USER_COLUMNS);
      }
    });
    effect(() => {
      const partnerColumns = this.displayedPartnerColumns();
      if (partnerColumns.length) {
        localStorage.setItem(DISPLAYED_PARTNER_COLUMNS, JSON.stringify(partnerColumns));
      } else {
        localStorage.removeItem(DISPLAYED_PARTNER_COLUMNS);
      }
    });
    effect(() => {
      const itemsPerPage = this.itemsPerPage();
      if (itemsPerPage) {
        localStorage.setItem(ITEMS_PER_PAGE, itemsPerPage + '');
      } else {
        localStorage.removeItem(ITEMS_PER_PAGE);
      }
    });
  }

  async init(): Promise<void> {
    if (!this.isBrowser) {
      return;
    }
    const moduleConfigColumns = localStorage.getItem(DISPLAYED_MODULE_CONFIG_COLUMNS);
    const boxColumns = localStorage.getItem(DISPLAYED_BOX_COLUMNS);
    const customerColumns = localStorage.getItem(DISPLAYED_CUSTOMER_COLUMNS);
    const userColumns = localStorage.getItem(DISPLAYED_USER_COLUMNS);
    const adminUserColumns = localStorage.getItem(DISPLAYED_ADMIN_USER_COLUMNS);
    const partnerColumns = localStorage.getItem(DISPLAYED_PARTNER_COLUMNS);
    const itemsPerPage = +(localStorage.getItem(ITEMS_PER_PAGE) ?? '20');
    this.displayedModuleConfigColumns.set(
      moduleConfigColumns
        ? ModuleConfigColumn.filter(JSON.parse(moduleConfigColumns))
        : ModuleConfigColumn.displayedColumns,
    );
    this.displayedBoxColumns.set(
      boxColumns ? CustomerBoxColumn.filter(JSON.parse(boxColumns)) : CustomerBoxColumn.displayedColumns,
    );
    this.displayedCustomerColumns.set(
      customerColumns ? CustomerColumn.filter(JSON.parse(customerColumns)) : CustomerColumn.displayedColumns,
    );
    this.displayedUserColumns.set(
      userColumns ? UserColumn.filter(JSON.parse(userColumns)) : UserColumn.displayedColumns,
    );
    this.displayedAdminUserColumns.set(
      adminUserColumns ? UserColumn.filter(JSON.parse(adminUserColumns)) : UserColumn.displayedAdminColumns,
    );
    this.displayedPartnerColumns.set(
      partnerColumns ? PartnerColumn.filter(JSON.parse(partnerColumns)) : PartnerColumn.displayedColumns,
    );
    this.itemsPerPage.set(itemsPerPage);
  }
}
